<template>
  <Content
    header-image-src="/img/content/img-contents-thumb-1l.webp"
    :header-title="['eSIM 지원 기종,', '구매 전 체크해 보세요']"
    date="2025.01.23"
  >
    <p class="typo-1 mt-8 mb-30">
      여행자님, 단 1분 만에 인터넷에 연결 가능한 eSIM으로 간편한 여행을 준비 중이신가요?<br />
      그렇다면 사용 중인 휴대폰 기기가 eSIM을 지원하는지 먼저 체크하는 게 중요해요.
    </p>

    <div class="title-typo-1 bg-sub mb-default">eSIM 지원 기종 📱</div>
    <nuxt-img
      :src="url(ESIM_DEVICE_INFO_IMAGE)"
      class="w-full"
    />

    <div class="title-typo-1 bg-sub mt-30 mb-default">구매 전 꼭 확인하세요! 🛒</div>
    <p class="typo-2 mb-30">
      eSIM을 먼저 구매한 후, 휴대폰이 eSIM 미지원 기종임을 뒤늦게 알게 된다면 여행지에서 인터넷
      연결이 안 되거나 현지 데이터를 새로 구매해야 하는 불편을 겪으실 수 있어요. 그렇기 때문에
      <b>여행 데이터 구매 전, eSIM 지원 기종을 꼭 확인</b>해보시길 바랍니다!
    </p>
    <nuxt-img
      id="gtm_contents_usim_click_banner"
      class="w-full point-cursor"
      src="/img/content/img-contents1-banner1.webp"
      @click="handleMoveRocketDelivery"
    />
  </Content>
</template>

<script setup lang="ts">
import { ESIM_DEVICE_INFO_IMAGE } from '@/constants/image/blob'
const { url } = useBlob()
definePageMeta({
  layout: 'center'
})

const handleMoveRocketDelivery = () => {
  window.location.href = '/contents/usim-rocket-delivery'
}

useHead({
  title: 'eSIM 지원 기종, 구매 전 체크해 보세요',
  meta: [
    {
      hid: 'description',
      name: 'description'
    }
  ]
})
</script>
